import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.usuarios.personal.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Persona ha sido creada con éxito."}
                title={"Nueva Persona"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                buttonClass={this.props.buttonClass}
            >
                <Row>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-6">
                        <Label>DNI</Label>
                        <Input type="text" name="dni"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Domicilio</Label>
                        <Input type="text" name="domicilio"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-8">
                        <Label>Email</Label>
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>



                <Row>
                    <Col className="col-12">
                        <Label>Grupos</Label>
                        <ParadigmaAsyncSeeker fieldName={""}
                            url={api.usuarios.grupos.select}
                            value={this.state.departamentopadre_id} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row>
                    <Col className="col-12">
                        <Label>Subgrupos</Label>
                        <ParadigmaAsyncSeeker fieldName={"departamento_id"}
                            url={api.usuarios.subgrupos.select + (this.state.departamentopadre_id ? "?grupo=" + this.state.departamentopadre_id : "")}
                            value={this.state.departamento} />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Personal/Create.js